import { render, staticRenderFns } from "./GlobalBanner.vue?vue&type=template&id=79e22498&"
import script from "./GlobalBanner.vue?vue&type=script&lang=js&"
export * from "./GlobalBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentfulTextBanner: require('/~/src/modules/contentful/components/Widget/TextBanner.vue').default})
